import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import { Partner } from './types/partner';
import Icon from '../../../common/components/icon/Icon';
import styles from './partnerLogoList.module.scss';
import { getCurrentLanguage } from '../../../common/translation/TranslationUtils';

type Props = {
  size: 'big' | 'small';
  partners: Partner[];
};

const Partners = (props: Props) => {
  const { i18n, t } = useTranslation();
  const currentLocale = getCurrentLanguage(i18n);
  const partners = props.partners;
  return (
    <div className={styles[props.size]}>
      {partners.map((partner: Partner) => {
        const icon = partner.altLangIcons?.[currentLocale]
          ? partner.altLangIcons[currentLocale]
          : partner.icon;
        const href = partner.url[currentLocale]
          ? partner.url[currentLocale]
          : partner.url.fi;

        return (
          <a
            key={partner.name}
            href={href}
            className={classnames(
              styles.container,
              partner.iconClassName && styles[partner.iconClassName]
            )}
          >
            <Icon
              className={styles.icon}
              src={icon}
              alt={t(`home.partners.partner.${partner.name}`)}
            />
          </a>
        );
      })}
    </div>
  );
};

export default Partners;
